import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, of, Subject } from 'rxjs';
import { first, map, takeUntil } from 'rxjs/operators';
import { ApplicationService } from 'services/application/application.service';
import { DialogService } from 'services/dialogs/dialogs.service';
import { ErrorService } from 'services/error/error.service';
import { NotificationService } from 'services/notification/notification.service';
import { UserService } from 'services/user/user.service';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(appSvc, dialogSvc, errorSvc, notificationsSvc, router, userSvc) {
        this.appSvc = appSvc;
        this.dialogSvc = dialogSvc;
        this.errorSvc = errorSvc;
        this.notificationsSvc = notificationsSvc;
        this.router = router;
        this.userSvc = userSvc;
        this._subrelease = new Subject();
    }
    HomeComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    HomeComponent.prototype.ngOnInit = function () {
        var self = this;
        self.LastLogin = null;
        self.Notifications = [];
        self.User = null;
        self.ViewReady = false;
        // Wait for initial user object to be non-null before proceeding
        self.userSvc.UserSubject.pipe(takeUntil(self._subrelease), first(function (_u) { return !!_u; })).subscribe(function (_user) {
            self.User = _user;
            // Begin user object recycling.
            self.userSvc.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (user) {
                self.User = user;
                // If we still have a user object (ie, this isn't a logout), refetch notifications to keep them updated.
                if (self.User && self.User.AuthToken) {
                    self.notificationsSvc.GetNotifications(self.User.AuthToken, self.User.CurrentRole).subscribe(function (notices) {
                        self.LastLogin = notices.LastLogin;
                        self.Notifications = notices.Notifications;
                    }, function (error) { return self.errorSvc.HandleServiceError(error); });
                }
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
            // Load the notifications for the user. If the user is the superintendent or deputy, we also need to load summary stats as well.
            // Also ensure that everything we need for the current user is loaded.
            // const notificationsObs = self.notificationsSvc.GetNotifications(
            //     self.userSvc.User.AuthToken,
            //     self.userSvc.User.CurrentRole
            // );
            var summaryObs = self.userSvc.User.CurrentRole === 'Superintendent'
                ? of(null) // self.appSvc.GetSuperintendentSummaryStats(self.userSvc.User.AuthToken, self.userSvc.User.CurrentRole)
                : of(null);
            var referredToUserObs = self.appSvc.GetAllReferredToUsers(self.userSvc.User.AuthToken);
            combineLatest(summaryObs, referredToUserObs)
                .pipe(takeUntil(self._subrelease), map(function (_packet) {
                return {
                    SummaryStats: _packet[0],
                    ReferredToUsers: _packet[1],
                };
            }))
                .subscribe(function (packet) {
                // if (packet.Notifications) {
                //     self.LastLogin = packet.Notifications.LastLogin;
                //     self.Notifications = packet.Notifications.Notifications;
                // }
                self.SummaryStatus = packet.SummaryStats;
                self.ViewReady = true;
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
        }, function (error) { return self.errorSvc.HandleServiceError(error); });
    };
    // #region Show Notification Details
    HomeComponent.prototype.ShowNotificationDetails = function (details) {
        var self = this;
        if (!details || !details.length) {
            return;
        }
        self.dialogSvc
            .OpenNotificationDialog({
            TitleText: 'Notification Details',
            MessageText: 'The following items were referenced in this notification entry:',
            OKText: 'OK',
            Details: details,
            AsBoard: self.User.CurrentRole === 'BoardMember' || self.User.CurrentRole === 'BoardAssistant',
        })
            .subscribe(function (detail) {
            if (detail && detail.LinkState) {
                // User is opting to navigate to a specific detail. Transform the link state we're going to as needed
                var link = detail.LinkState.replace(':RequestID', '' + detail.RequestID)
                    .replace(':ReferralID', '' + detail.ReferralID)
                    .replace(':PreviousPage', 'home');
                self.router.navigate(link.split('/'));
            }
        });
    };
    return HomeComponent;
}());
export { HomeComponent };
